import React, { useState, useEffect } from "react";
import EmbedVideo from "../EmbedVideo";
import { useSelector } from "react-redux";

const ProductVideo = ({
  videoDescs,
  onFormVideo,
  onAddVideoDesc,
  onRemoveVideo,
  approval_status,
  next_step_nik_detail,
}) => {
  let { userInfo } = useSelector((state) => state.auth);
  /*const [fileUrls, setFileUrls] = useState([]);

  useEffect(() => {
    if (files?.length > 0) {
      // Create object URLs for the files
      const newFileUrls = files.map((file) => {
        if (!file.url) {
          return URL.createObjectURL(file);
        } else return file.url;
      });

      // Update state with the new file URLs
      setFileUrls((prevUrls) => [...prevUrls, ...newFileUrls]);

      // Clean up the URL objects when the component unmounts or files change
      return () => {
        newFileUrls.forEach((url) => URL.revokeObjectURL(url));
      };
    }
  }, [files]);*/
  return (
    <div className="card">
      <div className="card-header">
        <div className="card-title" style={{ width: "100%" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div>
              <i className="fab fa-youtube" /> Video
            </div>
            <div>
              {approval_status != "ONPROGRESS" &&
                (approval_status != "ONREVISED" ||
                  next_step_nik_detail == userInfo.nik) && (
                  <a
                    type="button"
                    className="btn btn-outline-warning btn-pmc"
                    style={{ width: 120 }}
                    onClick={onFormVideo}
                  >
                    <i className="fab fa-youtube" /> Choose{" "}
                  </a>
                )}
            </div>
          </div>
        </div>
      </div>
      <div className="card-body">
        <div className="form-group">
          <div
            className="d-flex"
            style={{ margin: "16px 0", flexFlow: "wrap", padding: 10 }}
          >
            {videoDescs.length > 0 &&
              videoDescs.map((video, i) => {
                const paddingStyle =
                  video.content_types.length > 0
                    ? { marginRight: 115 }
                    : { marginRight: 20 };

                return (
                  <div
                    key={"key_file_" + i}
                    style={{
                      display: "flex",
                      width: 175,
                      height: 100,
                      ...paddingStyle,
                    }}
                    className="mb-5 mt-2"
                  >
                    <EmbedVideo
                      key={i}
                      url={video?.filePath?.replace(
                        "YOUTUBE_VIDEO_ID",
                        video.fileName
                      )}
                      onCLick={() => onAddVideoDesc(video)}
                      visibleDelete={
                        approval_status !== "ONPROGRESS" &&
                        (approval_status !== "ONREVISED" ||
                          next_step_nik_detail == userInfo.nik)
                      }
                      onRemove={(e) => onRemoveVideo(i)}
                      language_name={video.language_name}
                    />
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        marginRight: 10,
                      }}
                      className="ml-1"
                    >
                      <div style={{ width: 85, marginTop: 15 }}>
                        {video.media_types.map((item, i) => {
                          if (i < 2) {
                            return (
                              <p
                                key={"content_" + item}
                                style={{
                                  fontSize: 12,
                                  marginTop: -15,
                                  backgroundColor: "#ffe99b",
                                  paddingLeft: 2,
                                  borderRadius: 5,
                                  color: "#000",
                                }}
                              >
                                {item}
                              </p>
                            );
                          }
                        })}

                        {video.media_types.length - 2 > 0 && (
                          <p
                            key={"media_video_key"}
                            style={{
                              fontSize: 12,
                              marginTop: -15,
                              backgroundColor: "#ffe99b",
                              paddingLeft: 2,
                              borderRadius: 5,
                              width: 35,
                              color: "#000",
                            }}
                          >
                            {video.media_types.length - 2}+
                          </p>
                        )}
                      </div>

                      <div style={{ width: 85, marginTop: 5 }}>
                        {video.content_types.map((item, i) => {
                          if (i < 2) {
                            return (
                              <p
                                key={"content_" + item}
                                style={{
                                  fontSize: 12,
                                  marginTop: -15,
                                  backgroundColor: "#ffe99b",
                                  paddingLeft: 2,
                                  borderRadius: 5,
                                  color: "#000",
                                }}
                              >
                                {item}
                              </p>
                            );
                          }
                        })}

                        {video.content_types.length - 2 > 0 && (
                          <p
                            key={"content_video_key"}
                            style={{
                              fontSize: 12,
                              marginTop: -15,
                              backgroundColor: "#ffe99b",
                              paddingLeft: 2,
                              borderRadius: 5,
                              width: 35,
                              color: "#000",
                            }}
                          >
                            {video.content_types.length - 2}+
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductVideo;
